import { getUrlParameter } from "./url-parameter"

export const appLanguage = () => getUrlParameter("locale")
